<div class="result-button-container">
  <button
    class="btn btn-outline-primary btn-result"
    (click)="onChangeResult()"
    [disabled]="readonly">
    @if (result.yesNoValue === null) {
      <span>&nbsp;</span>
    }
    @if (result.yesNoValue === true) {
      <span translate>Ja</span>
    }
    @if (result.yesNoValue === false) {
      <span translate>Nein</span>
    }
  </button>
</div>
